module.exports = __webpack_public_path__ + "static/media/USER_AGREEMENT.ffd081dd.md";